import {
  OrderManagementPermissions,
  ReturnsAndClaimsPermissions,
} from "@redotech/account-common/permissions";
import { RedoSecondaryNavItem } from "@redotech/arbiter/navigation/secondary/redo-secondary-nav-item";
import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import Edit02Icon from "@redotech/redo-icons/edit-02.svg";
import Edit02FilledIcon from "@redotech/redo-icons/edit-02_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { memo } from "react";

export const OrderEditsItem = memo(function OrderEditsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { t } = useTranslation();

  const hasPermissionToViewItem = useHasPermission(
    OrderManagementPermissions.VIEW_ORDER,
    ReturnsAndClaimsPermissions.VIEW_RETURN,
    ReturnsAndClaimsPermissions.MANAGE_WARRANTY,
    ReturnsAndClaimsPermissions.MANAGE_PACKAGE_PROTECTION_CLAIM,
    OrderManagementPermissions.MANAGE_SHIPMENTS,
  );

  if (!hasPermissionToViewItem) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.orderEditsHref }}
      FilledIcon={Edit02FilledIcon}
      friendlyName={t("Order editing", {
        context:
          "order, fulfillment, claims, and warehouse operations navigation label",
      })}
      id="order-edits"
      UnfilledIcon={Edit02Icon}
    />
  );
});
